import { useTranslation } from "react-i18next";
import Icon from "./Icon";

export function ServiceCard() {
    const { t } = useTranslation();

    return (
        <div className={`flex flex-col md:flex-row w-full items-center max-w-[522px] bg-gray-100 rounded-[12px] overflow-hidden`}>
            <img className="hidden md:block md:max-w-[73px] h-[126px] object-cover" src="/images/service-desktop.png" />
            <img className="md:hidden md:max-w-[73px] h-[126px] w-full object-cover object-top" src="/images/service-mobile.png" />
            <div className="flex flex-col w-full justify-center gap-3 py-[16px] px-[16px] md:py-[16px] md:px-[24px]">
                <div className="flex flex-col gap-1">
                    <h2 className="font-semibold text-gray-900">{t("service.card.title")}</h2>
                    <p className="text-gray-600">{t("service.card.subtitle")}</p>
                </div>
                <a
                    href={t("service.card.link")}
                    target="_blank"
                    className="flex items-center w-fit justify-center bg-white hover:bg-gray-100 border border-gray-300 shadow-[_0px_0.667px_1.333px_0px_rgba(16,24,40,0.05)] rounded-[6px] transition-background duration-200 px-[10px] py-[6px] gap-[5px] cursor-pointer"
                >
                    <span className="text-xs font-semibold text-gray-700">{t("service.card.button")}</span>
                    <Icon classNameIcon="h-[14px] w-[14px]" stroke="#3D4A67" icon="arrow-up-right" />
                </a>
            </div>
        </div >
    )
}